<template>
    <on-click-outside :do="hide">
        <div>
            <button
                :class="{ 'is-active': show }"
                class="dropdown-trigger text-white font-extrabold"
                aria-label="Visa sök"
                @click="toggle"
            >
                <slot />

                <div v-if="isSearchDropdown === true" class="flex items-center">
                    <font-awesome-icon
                        v-if="show"
                        icon="times"
                        class="ml-sm text-sm"
                    />
                    <font-awesome-icon
                        v-else
                        icon="search"
                        class="ml-sm text-xs"
                    />
                </div>
            </button>

            <transition name="slide-down">
                <div
                    v-show="show"
                    :class="{ 'bg-neutral-lighter': isGrey, 'bg-white': !isGrey }"
                    class="dropdown-content shadow-dropdown"
                >
                    <slot name="dropdown-content" />
                </div>
            </transition>

            <portal v-if="show" to="modals">
                <div class="fixed h-screen w-screen pin-t bg-modal z-40" />
            </portal>
        </div>
    </on-click-outside>
</template>

<script>
    export default {
        props: {
            isGrey: {
                required: false,
                type: Boolean,
                default: false,
            },
            isSearchDropdown: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                show: false,
            };
        },
        watch: {
            show(value) {
                if (value && this.isSearchDropdown) {
                    EventBus.$emit('global-search-opened');
                }
            },
        },
        methods: {
            toggle() {
                this.show = ! this.show;
                if (this.show) {
                    this.$emit('shown');
                }
            },
            hide() {
                this.show = false;
                EventBus.$emit('global-search-closed');
            },
        },
    };
</script>